/** Using local storage to persist some data */
export default class DataStorage {

    static setMigrationStartTime() {
        localStorage.setItem('migrationStartTime', new Date().getTime().toString());
    }

    static getSecondsPassedFromMigrationStart() {
        let startTime = localStorage.getItem('migrationStartTime');

        if (startTime !== null) {
            return Math.round(
                (new Date().getTime() - new Date(parseInt(startTime, 10)).getTime()) / 1000
            );
        }
        return null;
    }

    static getLastNotificationBubbled() {
        return localStorage.getItem('migrationLastStatusNotified');
    }

    static setLastNotificationBubbled(status: string) {
        return localStorage.setItem('migrationLastStatusNotified', status);
    }

    static setMigrationSuccessNotificationRead() {
        localStorage.setItem('migrationSuccessNotificationRead', "true");
    }

    static getMigrationSuccessNotificationRead() {
        return localStorage.getItem('migrationSuccessNotificationRead');
    }

    static setMigrationErrorShowed() {
        localStorage.setItem('migrationErrorShowed', "true");
    }

    static hasMigrationErrorShowed() {
        return localStorage.getItem('migrationErrorShowed');
    }

    static clearMigrationErrorShowed() {
        localStorage.removeItem('migrationErrorShowed');
    }

    static clear() {
        localStorage.removeItem('migrationStartTime');
        localStorage.removeItem('migrationLastStatusNotified');
        localStorage.removeItem('migrationSuccessNotificationRead');
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/externalwebsiteimport/DataStorage.ts
 **/